import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { HeaderContext } from '../../../../views/LayoutWithLeftSidebar/HeaderContext'
import { ConfigureAssignment } from './ConfigureAssignment/ConfigureAssignment'
import { MeetingInfo } from './MeetingInfo/MeetingInfo'
import { MeetingSummarySidebar } from './Sidebar/MeetingSummarySidebar'
import { MeetingSummaryHeader } from './Header/MeetingSummaryHeader'
import { MeetingResultsWrapper } from './MeetingResults/MeetingResultsWrapper'
import { MeetingSummaryToast } from './Toast/MeetingSummaryToast'
import { MeetingSummaryPoller } from './Poller/MeetingSummaryPoller'
import { MeetingSummaryInitialization } from './Initialization/MeetingSummaryInitialization'
import { useConsentCheck, useTrackRoomSessionOpened } from './hooks'
import { ConsentNotAvailable } from '../ConsentNotAvailable'
import { Col, Container, Row } from 'react-bootstrap'
import { MeetingOverallSentiment } from './SentimentAnalysis/MeetingOverallSentiment'
import { useZocksQuota } from '../../../../components/ScopedBlock/hooks'
import { useAccount } from '../../../../common/useAccount'
import { MeetingSummaryModalManager } from '../../../../components/MeetingSummaryModalManager/MeetingSummaryModalManager'

export const MeetingSummary: React.FC = () => {
  const { portalRef } = useContext(HeaderContext)
  useTrackRoomSessionOpened()
  const { account } = useAccount({ refetchOnMountOrArgChange: false })

  const { hasQuota } = useZocksQuota()

  const sentimentAnalysisEnabled = hasQuota('ai.sentimentAnalysis.value')

  const { meetingDisabledByConsent, consentLoading, meetingUnlocked } = useConsentCheck()

  if (!meetingUnlocked && (consentLoading || meetingDisabledByConsent)) {
    return <ConsentNotAvailable loading={consentLoading} />
  }

  return (
    <div className='full-size-content'>
      <MeetingSummaryInitialization />
      <>
        <MeetingSummaryPoller />
        <MeetingSummaryToast />
        {portalRef && portalRef.current ? createPortal(<MeetingSummaryHeader />, portalRef.current) : null}
        <MeetingSummarySidebar />
        <MeetingSummaryModalManager />
        <Container className='mw-100 w-100'>
          <Row>
            <Col>
              <MeetingInfo />
            </Col>
            {account?.effectiveConfig.sentimentAnalysis && sentimentAnalysisEnabled && (
              <Col className='p-0'>
                <MeetingOverallSentiment />
              </Col>
            )}
          </Row>
        </Container>
        <div className='p-0 zocks-mt-3.5 zocks-mb-3.5'>
          <ConfigureAssignment />
        </div>
        <MeetingResultsWrapper />
      </>
    </div>
  )
}
